(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["athlete-grid"] && !Shopify.designMode) return;
  try {
    
  {
    const lists = document.querySelectorAll('.athlete-grid__list');
    lists.forEach(function(list) {
      const items = Array.from(list.querySelectorAll('.athlete-grid__item'));
      items.sort(function(a, b) {
        const orderA = parseInt(a.dataset.sortOrder, 10) || 0;
        const orderB = parseInt(b.dataset.sortOrder, 10) || 0;
        if (orderA !== orderB) return orderA - orderB;
        return (a.dataset.name || '').localeCompare(b.dataset.name || '');
      });
      items.forEach(function(item) { list.appendChild(item); });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["free-shipping-promo"] && !Shopify.designMode) return;
  try {
    
  class FreeShippingPromo extends HTMLElement {
    static STALE_TOTAL_TIMEOUT = 10000;

    connectedCallback() {
      this.threshold = Number(this.dataset.threshold);
      this.onCartUpdate = () => this.refresh();
      this.onPageShow = (event) => {
        if (event.persisted) this.refresh();
      };

      document.addEventListener('cart:update', this.onCartUpdate);
      window.addEventListener('pageshow', this.onPageShow);
      this.ensureMessageIsCorrect();
    }

    disconnectedCallback() {
      document.removeEventListener('cart:update', this.onCartUpdate);
      window.removeEventListener('pageshow', this.onPageShow);
    }

    /**
     * Corrects the server-rendered message when Shopify served stale HTML.
     * Mirrors the sessionStorage guard in cart-icon.js.
     */
    ensureMessageIsCorrect() {
      const stored = sessionStorage.getItem('cart-total');
      if (stored === null) return;

      try {
        const { value, timestamp } = JSON.parse(stored);

        // Only trust the stored total if it was written recently
        if (Date.now() - timestamp < FreeShippingPromo.STALE_TOTAL_TIMEOUT) this.render(value);
      } catch (_) {
        // no-op
      }
    }

    async refresh() {
      const response = await fetch(`${window.Shopify.routes.root}cart.js`);
      if (!response.ok) return;

      const cart = await response.json();

      this.render(cart.total_price);
      sessionStorage.setItem('cart-total', JSON.stringify({ value: cart.total_price, timestamp: Date.now() }));
    }

    render(totalPrice) {
      const remaining = this.threshold - totalPrice;

      this.classList.toggle('fsp--qualified', remaining <= 0);

      const amount = this.querySelector('[ref="amount"]');
      if (amount && remaining > 0) amount.textContent = this.formatMoney(remaining);
    }

    formatMoney(cents) {
      const formatter = new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: window.Shopify.currency.active,
        currencyDisplay: 'narrowSymbol',
        minimumFractionDigits: cents % 100 === 0 ? 0 : 2,
      });

      return formatter.format(cents / 100);
    }
  }

  if (!customElements.get('free-shipping-promo')) {
    customElements.define('free-shipping-promo', FreeShippingPromo);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-athlete"]) return;
  try {
    
  const lightbox = document.getElementById('athlete-lightbox');
  const lightboxImg = lightbox.querySelector('.athlete-lightbox__img');
  const closeBtn = lightbox.querySelector('.athlete-lightbox__close');

  document.querySelectorAll('.athlete-page__gallery-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      lightboxImg.src = btn.dataset.lightboxSrc;
      lightboxImg.alt = btn.dataset.lightboxAlt;
      lightbox.hidden = false;
      document.body.style.overflow = 'hidden';
      closeBtn.focus();
    });
  });

  function closeLightbox() {
    lightbox.hidden = true;
    lightboxImg.src = '';
    document.body.style.overflow = '';
  }

  closeBtn.addEventListener('click', closeLightbox);

  lightbox.addEventListener('click', e => {
    if (e.target === lightbox) closeLightbox();
  });

  document.addEventListener('keydown', e => {
    if (e.key === 'Escape' && !lightbox.hidden) closeLightbox();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-slide-in"] && !Shopify.designMode) return;
  try {
    
  class NewsletterSlideIn extends HTMLElement {
    static STORAGE_KEY = 'newsletter-slide-in-dismissed';
    static CLOSE_DURATION = 4 * 60 * 60 * 1000;

    connectedCallback() {
      if (this.isDismissed()) return;

      this.onClick = (event) => {
        const button = event.target.closest('[data-dismiss]');
        if (button) this.dismiss(button.dataset.dismiss === 'forever');
      };
      this.addEventListener('click', this.onClick);

      // Exposes the panel height so other fixed elements (e.g. the Smile launcher) can sit above it
      this.resizeObserver = new ResizeObserver(() => {
        document.body.style.setProperty('--nls-height', `${this.offsetHeight}px`);
      });
      this.resizeObserver.observe(this);

      this.loadMailerLite();
      this.timer = setTimeout(() => this.showWhenReady(), Number(this.dataset.delay));
    }

    disconnectedCallback() {
      clearTimeout(this.timer);
      this.observer?.disconnect();
      this.resizeObserver?.disconnect();
      this.removeEventListener('click', this.onClick);
    }

    isDismissed() {
      try {
        const stored = localStorage.getItem(NewsletterSlideIn.STORAGE_KEY);
        return stored === 'forever' || Number(stored) > Date.now();
      } catch (_) {
        return false;
      }
    }

    dismiss(forever) {
      this.removeAttribute('data-open');

      try {
        const value = forever ? 'forever' : String(Date.now() + NewsletterSlideIn.CLOSE_DURATION);
        localStorage.setItem(NewsletterSlideIn.STORAGE_KEY, value);
      } catch (_) {
        // no-op
      }
    }

    loadMailerLite() {
      if (window.ml) return;

      window.ml = function () {
        (window.ml.q = window.ml.q || []).push(arguments);
      };

      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://assets.mailerlite.com/js/universal.js';
      document.head.appendChild(script);

      window.ml('account', this.dataset.account);
    }

    /**
     * Only slide in once MailerLite has rendered the form, so the panel never appears empty.
     */
    showWhenReady() {
      const embed = this.querySelector('.ml-embedded');

      if (embed.childElementCount) {
        this.setAttribute('data-open', '');
        return;
      }

      this.observer = new MutationObserver(() => {
        if (!embed.childElementCount) return;
        this.observer.disconnect();
        this.setAttribute('data-open', '');
      });
      this.observer.observe(embed, { childList: true });
    }
  }

  if (!customElements.get('newsletter-slide-in')) {
    customElements.define('newsletter-slide-in', NewsletterSlideIn);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-metafield-tabs"]) return;
  try {
    
  class ProductTabs extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
      this.tabs.forEach(tab => tab.addEventListener('click', () => this.selectTab(tab)));
    }

    selectTab(selectedTab) {
      this.tabs.forEach(tab => {
        const active = tab === selectedTab;
        tab.setAttribute('aria-selected', active);
        tab.classList.toggle('is-active', active);
      });
      this.panels.forEach(panel => {
        const active = panel.id === selectedTab.getAttribute('aria-controls');
        panel.classList.toggle('is-active', active);
        if (active) {
          panel.removeAttribute('hidden');
        } else {
          panel.setAttribute('hidden', '');
        }
      });
    }
  }

  customElements.define('product-tabs', ProductTabs);

  } catch(e) { console.error(e); }
})();
})();
